/* eslint-disable no-undef */
import axios from 'axios';

export const handleDeleteFile = async (key, index, files, setFiles, userInfo) => {
  let array = [...files];
  let newIndex = index;
  if (newIndex !== -1) {
    array.splice(newIndex, 1);
    setFiles(array);
    localStorage.setItem('localFiles', JSON.stringify(array));
  }
  try {
    const { data } = await axios.delete(`${process.env.REACT_APP_API_URL}/uploads/${key}`, {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    });
    console.log(data);
  } catch (error) {
    console.log(error);
  }
};
